import { createI18n } from "vue-i18n";

// Localisation language list
import { locale as en } from "@/core/config/i18n/en";
import { locale as th } from "@/core/config/i18n/th";

let messages = {};
messages = { ...messages, en, th };

// get current selected language
export const lang = localStorage.getItem("language") || "th";

const i18n = createI18n({
  legacy: false,
  locale: lang, // set locale
  globalInjection: true,
  messages,
});

export default i18n;
